import React, { Component } from 'react'
import Lottie from 'react-lottie'
import css from './index.scss'


const animationData = require('../../assets/animations/empty_box.json')
const expiredAnimation = require('../../assets/animations/timer-w800-h800.json')

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
}

const animation = {
  expired: expiredAnimation,
}

export default class EmptyState extends Component {
  state = {}
  render() {
    return (
      <div
        className={css.container}
        style={{ height: this.props.size * 2, width: this.props.width }}
      >
        {
          this.props.noAnimation ? null : (
            <Lottie
              options={{
                ...defaultOptions,
                animationData: animation[this.props.type] || animationData,
                loop: !this.props.noLoop,
              }}
              height={this.props.size || 200}
              width={this.props.size || 200}
              isStopped={false}
              isPaused={false}
            />
          )
        }
        <span className={css.title}>
          {this.props.title}
        </span>
        <span className={css.caption}>
          {this.props.captionText}
        </span>
      </div>
    )
  }
}
